import { render } from "./InputTextCustom.vue?vue&type=template&id=7faf737c"
import script from "./InputTextCustom.vue?vue&type=script&lang=js"
export * from "./InputTextCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__